import * as types from "./actionTypes";

import axios from "axios";

export const createOrder = payload => dispatch => {
  axios
    .post(`${process.env.REACT_APP_API_URL}/order/new`, payload)
    .then(res =>
      dispatch({
        type: types.CREATE_ORDER_SUCCESS,
        payload: res.data.response
      })
    )
    .catch(err => err);
};



// WEBPACK FOOTER //
// ./src/modules/order/actions.js